var Modal = require("components/utility/AltModal");
var moment = require("moment");
var LoadingButton = require("components/utility/LoadingButton");

var CurrentUser = require("lib/account/CurrentUser");

require("users/students/student_report_modal.scss")

class StudentReportModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, evaluationAmount: ""
		};
	}
	show() {
		this.refs.modal.show();			
	}
	hideModal() { 
		this.refs.modal.hide();
		this.props.openReport()
	}

	changeEvaluation() {
		var evaluationValue = $(this.refs.evaluation_option).closest
			(".selfEvaluationForm").find("input:checked").val();
		this.setState({ evaluationAmount: evaluationValue })	
	}
	submitEvaluation(e) {
		$wr.nope(e)
		this.setState({ loading: true });
		var evaluationValue = $(this.refs.evaluation_option).closest
			(".selfEvaluationForm").find("input:checked").val();
		
		if (evaluationValue == undefined) {
			this.setState({ loading: false })
		} else {
			setTimeout(function(){			
				window.wrNotifications.triggerDropDownNotification({
					title: "Thank You", text: "Thank you for sharing that. The report is on it's way!",
					icon: "ok-sign"
				}, this.setState({ loading: false }));

				setTimeout(function() {
					this.hideModal()
				}.bind(this), 1200);
			}.bind(this), 500)	
		}
	}
	render() {
		var month = moment().subtract(1, "months").format('MMMM');
		var title = "How did your " + month  + " go?" 
		
		var modalBody = (
			<div className="evaluationContainer">
				<p className="initialInstructions">We know you were busy reading and writing. How do you think you did?</p>
				<form className="selfEvaluationForm" onSubmit={ this.submitEvaluation }>
					<div className="labelsContainer">
						<label>
							<input type="radio" name="learningRating" ref="evaluation_option" value={ StudentReportModal.OPTION_ONE } 
								checked={ this.state.evaluationAmount == StudentReportModal.OPTION_ONE } onChange={ this.changeEvaluation } />
								I did not try hard enough.
						</label>
						<label>
							<input type="radio" name="learningRating" ref="evaluation_option" value={ StudentReportModal.OPTION_TWO}
								checked={ this.state.evaluationAmount == StudentReportModal.OPTION_TWO } onChange={ this.changeEvaluation } />
								I tried a bit, but I can do better.
						</label>
						<label>
							<input type="radio" name="learningRating" ref="evaluation_option" value={ StudentReportModal.OPTION_THREE = "option three" } 
								checked={ this.state.evaluationAmount == StudentReportModal.OPTION_THREE } onChange={ this.changeEvaluation }/>
								I tried hard and did well.
						</label>
						<label>
							<input type="radio" name="learningRating" ref="evaluation_option" value={ StudentReportModal.OPTION_FOUR = "option four" } 
								checked={ this.state.evaluationAmount == StudentReportModal.OPTION_FOUR } onChange={ this.changeEvaluation }/> 
								I worked really hard and did amazing work!
						</label>
					</div>
					<p className="extraCoinsText">(Want extra coins? Tell us about what you think you did well and where you want to improve.)</p>
					<textArea className="form-control evaluationTextArea" rows="2" cols="20" ref="evaluation_option" />
					<LoadingButton className="btn buttonSuccess" loading={ this.state.loading } text="View My Progress!" />
				</form>
			</div>
		) 
		return (
			<Modal className="studentReportModal" ref="modal" headerText={title}>
				{ modalBody }
			</Modal>
		)
	}
}

StudentReportModal.OPTION_ONE = "option one"
StudentReportModal.OPTION_TWO = "option two"
StudentReportModal.OPTION_THREE = "option three"
StudentReportModal.OPTION_FOUR = "option four"

StudentReportModal.propTypes = PageStrictPropTypes({
	openReport: PropTypes.func.isRequired
});

module.exports = StudentReportModal;


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentReportModal.js